import NavigableValidation from "./navigableValidation";
import DashboardElement from "~/models/dashboards/dashboardElement";
import {IErrorNavOpts} from "~/models/validationError";

export default class DashboardElementValidation<T> extends NavigableValidation<DashboardElement> {
  validators = [];

  errorNavOpts(validator, validatorKey: string, value?, errorType?): IErrorNavOpts{
    const opts = super.errorNavOpts(validator, validatorKey, value, errorType);
    const targetElementId = validator.options.targetElementId || this.model.idForProp(validatorKey);
    Object.assign(opts, {
      path: validator.section.toLowerCase(),
      query: {selectedId: this.model.client_id},
      targetElementId: targetElementId
    })
    return opts;
  }
}